import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=2d45e182&scoped=true&"
import script from "./PaginationControls.vue?vue&type=script&lang=js&"
export * from "./PaginationControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45e182",
  null
  
)

export default component.exports